<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M174 1177 c-46 -26 -58 -86 -25 -128 10 -13 21 -46 23 -73 10 -86 76
-146 160 -146 56 0 80 10 125 53 87 82 50 262 -60 296 -42 12 -199 11 -223 -2z
m23 -64 c-17 -29 -23 -34 -25 -20 -2 10 4 27 14 38 28 32 35 22 11 -18z m188
23 c33 -14 75 -66 75 -93 0 -21 -17 -15 -56 19 -25 22 -40 29 -49 22 -51 -37
-69 -46 -106 -51 -40 -6 -41 -5 -34 18 16 50 42 75 95 92 26 9 39 7 75 -7z
m24 -132 c28 -15 51 -33 51 -41 0 -7 -15 -29 -33 -49 -62 -68 -170 -51 -204
33 l-13 32 38 7 c20 4 53 15 72 25 19 10 36 18 37 19 0 0 24 -12 52 -26z"
      />
      <path
        d="M550 1065 c0 -13 36 -15 275 -15 l275 0 0 -249 0 -249 -35 -12 c-19
-6 -44 -22 -57 -35 -12 -13 -26 -21 -31 -18 -16 10 -135 5 -153 -6 -15 -8 -1
-10 64 -11 48 0 82 -4 82 -10 0 -6 -37 -10 -90 -10 -73 0 -90 -3 -90 -15 0
-12 16 -15 85 -15 l85 0 0 -31 c0 -65 50 -128 113 -144 66 -17 12 -25 -190
-27 -164 -2 -217 -6 -221 -16 -3 -10 45 -12 230 -10 230 3 233 3 236 25 2 13
13 24 29 28 64 16 113 81 113 150 0 62 -47 126 -106 145 l-34 11 -2 262 -3
262 -287 3 c-252 2 -288 0 -288 -13z m657 -589 c75 -82 20 -206 -92 -206 -76
0 -125 51 -125 131 0 35 6 47 40 81 39 39 42 40 92 36 44 -5 57 -11 85 -42z"
      />
      <path
        d="M1140 390 c-55 -49 -55 -49 -75 -30 -25 23 -35 25 -35 7 0 -14 41
-57 54 -57 15 0 126 102 126 116 0 22 -11 16 -70 -36z"
      />
      <path
        d="M718 965 c-15 -8 -31 -30 -38 -49 -6 -19 -19 -36 -30 -39 -27 -7 -25
-27 3 -27 15 0 28 -11 41 -34 16 -29 42 -55 112 -108 14 -11 113 68 133 106
10 19 22 26 43 26 18 0 28 5 28 15 0 9 -9 15 -25 15 -16 0 -25 6 -25 15 0 31
-30 72 -60 85 -27 11 -36 11 -59 -3 -23 -13 -29 -13 -45 -1 -25 18 -44 17 -78
-1z m73 -34 c24 -19 25 -19 48 0 13 10 29 19 37 19 21 0 54 -37 54 -60 0 -16
-7 -20 -37 -20 -20 0 -45 7 -55 17 -17 15 -20 15 -47 -11 -25 -24 -29 -25 -41
-11 -7 8 -21 15 -31 15 -25 0 -24 25 1 50 25 25 41 25 71 1z m45 -80 c5 -5 27
-11 49 -13 l40 -3 -48 -47 c-27 -27 -54 -48 -61 -48 -15 0 -106 86 -106 100 0
15 11 12 35 -10 l21 -20 24 25 c26 28 31 29 46 16z"
      />
      <path
        d="M198 813 c-129 -43 -188 -153 -188 -346 0 -92 13 -126 53 -145 19 -9
27 -21 27 -38 0 -33 28 -86 43 -81 13 4 13 15 1 84 -6 39 -4 44 46 105 30 36
72 73 97 86 56 29 71 58 49 100 -20 38 -52 48 -102 32 -45 -15 -114 -76 -114
-101 0 -28 17 -23 66 20 41 36 88 56 106 44 5 -2 8 -13 8 -24 0 -13 -12 -24
-40 -35 -27 -11 -57 -38 -95 -85 -31 -38 -63 -69 -71 -69 -33 0 -43 89 -24
209 20 118 68 178 166 207 41 12 54 20 52 32 -4 23 -24 24 -80 5z"
      />
      <path
        d="M404 819 c-9 -15 2 -23 64 -49 39 -17 56 -20 64 -12 17 17 -6 38 -59
56 -55 19 -60 19 -69 5z"
      />
      <path
        d="M561 736 c-14 -17 -7 -36 14 -36 22 0 29 20 13 36 -13 13 -16 13 -27
0z"
      />
      <path
        d="M463 679 c-14 -14 -7 -32 29 -83 34 -48 35 -53 1 -88 -22 -23 -24
-30 -13 -43 7 -8 17 -12 23 -8 17 10 2 -130 -17 -159 -9 -14 -37 -33 -62 -43
-57 -22 -79 -53 -70 -100 6 -32 5 -35 -18 -35 -14 0 -46 7 -72 16 -35 12 -49
13 -58 4 -8 -9 -5 -16 12 -30 74 -61 299 -16 365 72 68 91 92 187 85 341 -6
108 -21 160 -47 155 -17 -4 -17 -2 -1 -127 26 -194 -43 -367 -160 -402 -35
-11 -43 -10 -56 3 -21 21 -4 53 33 63 85 21 110 75 115 246 3 120 2 125 -23
159 -14 19 -29 43 -32 53 -7 20 -18 22 -34 6z"
      />
      <path
        d="M706 635 c5 -12 34 -15 170 -15 139 0 164 -2 164 -15 0 -13 -24 -15
-155 -15 -132 0 -155 -2 -155 -15 0 -13 23 -15 168 -13 l167 3 3 43 3 42 -185
0 c-161 0 -185 -2 -180 -15z"
      />
      <path
        d="M243 414 c-39 -39 -31 -76 30 -139 29 -30 57 -55 63 -55 12 1 52 37
87 78 36 44 37 93 2 120 -19 15 -40 20 -91 20 -57 0 -71 -4 -91 -24z m113 -26
c23 13 54 -2 54 -26 0 -10 -17 -35 -38 -55 l-39 -38 -36 41 c-41 45 -43 52
-22 74 12 12 21 13 39 5 16 -8 30 -8 42 -1z"
      />
      <path
        d="M790 395 c0 -11 7 -15 23 -13 12 2 22 8 22 13 0 6 -10 11 -22 13 -16
2 -23 -2 -23 -13z"
      />
      <path
        d="M855 400 c-8 -12 20 -24 35 -15 6 3 8 11 5 16 -8 12 -32 12 -40 -1z"
      />
      <path
        d="M150 170 c0 -15 5 -20 18 -18 9 2 17 10 17 18 0 8 -8 16 -17 18 -13
2 -18 -3 -18 -18z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
